import { useTranslation } from 'react-i18next';

import { FormLabel as BaseFormLabel, FormLabelProps as BaseFormLabelProps, forwardRef, Text } from '@bonusly/design-system';

type FormLabelProps = BaseFormLabelProps & {
	isOptional?: boolean;
};

export const FormLabel = forwardRef<FormLabelProps, 'label'>(({ isOptional, ...rest }, ref) => {
	const { t } = useTranslation('components', { keyPrefix: 'form' });

	return (
		<BaseFormLabel
			ref={ref}
			{...(isOptional && {
				optionalIndicator: (
					<Text color="text.softest" display="inline-block" float="right" fontSize={50} fontWeight="normal" lineHeight={5}>
						{t('optional')}
					</Text>
				),
			})}
			{...rest}
		/>
	);
});
